import { Icon, IconName } from "../lib";

type Props = {
  active?: boolean;
  routeName: string;
};

function getIconName(routeName: string, active: boolean): IconName {
  if (routeName === "Home") {
    return active ? "home" : "home-outline";
  }

  if (routeName === "Profile") {
    return active ? "account" : "account-outline";
  }

  if (routeName === "Chats") {
    return active ? "chat-processing" : "chat-processing-outline";
  }

  if (routeName === "Timeline") {
    return active ? "video" : "video-outline";
  }

  throw new Error(`Unknown route name: ${routeName}`);
}

export function TabBarIcon({ active = false, routeName }: Props) {
  return (
    <Icon
      name={getIconName(routeName, active)}
      color={active ? "onSurface" : "onSurfaceDim"}
    />
  );
}
